// extracted by mini-css-extract-plugin
export default {"titleWrapper":"loginLeftPanel_titleWrapper__GfNug","title":"loginLeftPanel_title__dOfOF","logoFacilsure":"loginLeftPanel_logoFacilsure__fLsJ6"};